import { useMemo } from 'react';

import { useUser, useStudent } from 'applications/GSP/shared/hooks/user';

export const useSelectableStudents = () => {
  const user = useUser();
  const student = useStudent();

  return useMemo(
    () => (user?.students || []).filter(({ id }) => id !== student?.id),
    [user?.students, student?.id],
  );
};
